<template>
  <div class="page">
    <div class="button-container">
      <el-button type="primary" @click="downloadDo" class="feature-secondary">
        Print Instruction
      </el-button>
    </div>
    <div class="job-instruction" id="job-instruction" v-if="!loading">
      <unloading-instruction-template
        v-for="index in pageCount"
        :key="'page-' + index"
        class="unloading-instruction-template"
        :basic-info="basicInfo"
        :qr-code-info="qrCodeInfo"
        :groups="groups.slice((index - 1) * cntPerPage, index * cntPerPage)"
        :current-page="index"
        :page-count="pageCount"
        :short-container-no="shortContainerNo"
      />
    </div>
  </div>
</template>

<script>
// apis
import { detailJob } from '@/api/job'
import { queryOrders } from '@/api/order'
import { queryContainers } from '@/api/container'
// utils
import { transferDbDate } from '@/core/utils/date'
import { downloadPdf } from '@/core/utils/pdf'
// components
import UnloadingInstructionTemplate from '@/components/jobs/UnloadingInstructionTemplate.vue'

export default {
  name: 'JobInstruction',
  components: {
    UnloadingInstructionTemplate
  },
  data() {
    return {
      jobDetail: {},
      jobOrder: null,
      groups: [],
      loading: false,
      cntPerPage: 6,
      shortContainerNo: ''
    }
  },
  computed: {
    jobNo() {
      return this.$route.params.no
    },
    jobId() {
      return this.jobDetail?.id ?? ''
    },
    orderNo() {
      return this.jobOrder?.no ?? ''
    },
    riiOrderNo() {
      return this.jobOrder?.riiOrderNo ?? ''
    },
    customer() {
      return this.jobOrder?.customer ?? ''
    },
    containerNo() {
      return this.jobDetail?.containerNo ?? ''
    },
    pageCount() {
      return Math.ceil(this.groups.length / this.cntPerPage)
    },
    estimatedDeliveryDate() {
      return this.jobOrder?.container.estimatedDeliveryDate ?? ''
    },
    basicInfo() {
      return [
        { label: 'Con#', value: this.containerNo },
        { label: 'Ref#', value: this.riiOrderNo },
        { label: 'Customer', value: this.customer },
        {
          label: 'Date',
          value: transferDbDate(this.estimatedDeliveryDate)
        }
      ]
    },
    qrCodeInfo() {
      return {
        type: 'Job',
        id: this.jobId,
        jobNo: this.jobNo,
        containerNo: this.containerNo,
        riiOrderNo: this.riiOrderNo
      }
    }
  },
  methods: {
    async getJobDetail() {
      this.loading = true
      const res = await detailJob(this.jobNo)
      this.$set(this, 'jobDetail', res)
      await this.getJobOrder()
      const groups = this.jobDetail.goodsGroups
      groups.sort((a, b) => a.name.localeCompare(b.name))
      groups.forEach(group => {
        let note = ''
        if ((group.notes ?? []).length > 0) {
          note = group.notes.map(e => e.content).join('\n')
        }
        this.groups.push({ groupName: group.name, cnt: group.quantity, note: note })
      })
      this.groups.push(
        ...Array(Math.ceil(groups.length / 6) * 6 - groups.length).fill({
          groupName: '',
          cnt: NaN,
          note: ''
        })
      )
      this.getContainerNo()
      this.loading = false
    },
    async getJobOrder() {
      const res = await queryOrders({ ids: this.jobDetail.orderId })
      if (res) {
        this.jobOrder = res[0]
      }
    },
    async downloadDo() {
      const pdf = await this.getPdf(
        '.unloading-instruction-template',
        'a4',
        'l'
      )
      downloadPdf(pdf, '111')
    },
    async getContainerNo() {
      queryContainers({ containerNos: [this.containerNo] }).then(containerList => {
        const container = containerList[0]
        this.shortContainerNo = container.no
      })
    }
  },
  mounted() {
    this.getJobDetail()
  },
  watch: {}
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.page {
  padding: 20px;

  @extend .f-c;

  gap: 20px;

  .job-instruction {
    @extend .f-c;

    gap: 20px;

    .unloading-instruction-template {
      width: 100%;
    }
  }
}
</style>
